export const playerManagement = {
  playerManagement: {
    edit: {
      title: "Edit Player",
      nickname: "Nickname",
      gender: "Gender",
      currency: "Currency",
      block_status: "Block Status",
      language: "Language",
      locale: "Locale",
    },
    columns: {
      tenant: "Tenant",
      username: "Username",
      block_status: "Block Status",
      created_at: "Created At",
      currency: "Currency",
      game_id: "Game ID",
      gender: "Gender",
      language: "Language",
      lobby_id: "Lobby ID",
      locale: "Locale",
      nickname: "Nickname",
      session_id: "Session ID",
      table_id: "Table ID",
      user_id: "User ID",
      lobby: "Lobby",
      player_id: "Player ID",
      player_name: "Player Name",
      risk_group: "Risk Group",
      created_date: "Created Date",
      account_status: "Account Status",
    },
    filters: {
      playerId: "Player ID",
      playerId_placeholder: "Enter Player ID",
      playerName: "Player Name",
      searchWithPlayerName: "Search With Player Name",
      playerName_placeholder: "Enter Player Name",
      lobbyId: "Lobby ID",
      lobbyId_placeholder: "Enter Lobby ID",
      nickname: "Nickname",
      nickname_placeholder: "Enter Nickname",
      currency: "Currency",
      currency_placeholder: "Enter Currency",
      title: "Player Search",
      search: "Search",
    },
    playerEditDrawer: {
      tabs: {
        profile: "'s Profile",
        transactions: "'s Transactions",
      },
      profile: {
        title: "User Name",
        userTransaction: "User Transaction",
        lobby: "Lobby",
        brand: "Brand",
        userId: "User ID",
      },
    },
  },
};
